import React from 'react'

import { Flex, Icon, Text } from '@driftt/dds'
import { faArrowPointer } from '@driftt/dds.icons/light/faArrowPointer'
import { faEye } from '@driftt/dds.icons/light/faEye'

import { TruncatedText } from 'components/TruncatedText'
import { EmailActivityPreview, EmailInteractions } from 'modules/accountActivity/domain'

interface EmailContentProps {
  preview?: EmailActivityPreview
  interactions?: EmailInteractions
}

export const EmailContent = ({ preview, interactions }: EmailContentProps) => {
  return (
    <Flex direction="column" css={{ paddingTop: '16px' }}>
      {/* subject and body preview */}
      {preview?.subject && <Text variant="metadata">{preview.subject}</Text>}
      {preview?.description && (
        <TruncatedText content={preview.description.replace(/\s\s+/g, ' ')} />
      )}

      {/* inbound fallback message */}
      {!preview?.subject && !preview?.description && !interactions && `Sent an email`}

      {/* interaction metadata */}
      {interactions && (
        <Flex alignItems="center" css={{ marginTop: '8px' }}>
          <Flex gap="half" alignItems="center">
            <Icon icon={faEye} />
            <Text variant="metadata">{interactions.opens}</Text>
          </Flex>
          <Flex gap="half" alignItems="center">
            <Icon icon={faArrowPointer} />
            <Text variant="metadata">{interactions.clicks}</Text>
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}
